import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import "../OrderOptions.scss";
import { Container, Row } from "react-bootstrap";
import messages from "../../../assets/i18n";
import ItemList from "../../../containers/ItemList/ItemList";

function OrderOptionsItemsTab(props) {
    const { items } = props;
    const lang = useSelector(state => state.language.name)
    const pageMessages = messages[lang].orderOptions.items

    const headers = [
        pageMessages.headers.sku,
        pageMessages.headers.descricao,
        pageMessages.headers.tamBr,
        pageMessages.headers.tamMer,
        pageMessages.headers.pantone,
        pageMessages.headers.cor,
        pageMessages.headers.quantidade,
        pageMessages.headers.custo,
        pageMessages.headers.venda,
        pageMessages.headers.ref,
        pageMessages.headers.ean,
        pageMessages.headers.composicao,
        pageMessages.headers.nbm,
    ];

    const formatItemColor = (item, countryCode) => {

        let color = ''

        for (let i = 0; i < item.length; i++) {
            if ((item[i].caracteristicaTipo === 'Y_COR' || item[i].caracteristicaTipo === 'COR') && 
                (item[i].codCountry === countryCode || !item[i].codCountry)) {
                color = item[i].caracteristica;
                break;
            }
        }

       return color
    } 

    const formatItemColorCode = (item, countryCode) => {

        let colorId = ''

        for (let i = 0; i < item.length; i++) {
            if ((item[i].caracteristicaTipo === 'Y_COR' || item[i].caracteristicaTipo === 'COR') && 
                (item[i].codCountry === countryCode || !item[i].codCountry)) {
                colorId = item[i].caracteristicaId;
                break;
            }
        }

       return colorId
    } 

    const formatItemSize = (item, countryCode) => {

        let size = ''

        for (let i = 0; i < item.length; i++) {
            if ((item[i].caracteristicaTipo === 'Y_TAM' || item[i].caracteristicaTipo === 'TAM') && 
                (item[i].codCountry === countryCode || !item[i].codCountry)) {
                size = item[i].caracteristica;
                break;
            }
        }

       return size
    } 

    const listTable = items && items.map((item, i) => {
    
        return ([
            { 
                text:  item.codItem,
                maxLength: 4000
            },
            { 
                text:  item.detalheItems[0].descricaoCurta,
                maxLength: 4000
            },
            { 
                text:  formatItemSize(item.detalheItems[0].caracteristicas, 'BR'),
                maxLength: 4000
            },
            { 
                text:  formatItemSize(item.detalheItems[0].caracteristicas, 'UY'),
                maxLength: 4000
            },
            { 
                text:  formatItemColorCode(item.detalheItems[0].caracteristicas, 'BR'),
                maxLength: 4000
            },
            { 
                text:  formatItemColor(item.detalheItems[0].caracteristicas, 'BR'),
                maxLength: 4000
            },
            { 
                text:  item.qtCompra,
                maxLength: 4000
            },
            { 
                text:  item.custoUnitario,
                maxLength: 4000
            },
            { 
                text:  item.precoCusto,
                maxLength: 4000
            },
            { 
                text:  item.detalheItems[0].vpn,
                maxLength: 4000
            },
            { 
                text:  item.detalheItems[0].ean,
                maxLength: 4000
            },
            { 
                text:  item.detalheItems[0].composicao,
                maxLength: 4000
            },
            { 
                text:  item.detalheItems[0].ncm,
                maxLength: 4000
            },
        ])
    })

    return (
        <Container>
            <Row>
                <ItemList
					header={headers}
					listTable={listTable}/>
            </Row>
        </Container>
    );
}

OrderOptionsItemsTab.propTypes = {
    items: PropTypes.array
};

const mapStateToProps = state => ({
    lang: state.language
});

export default connect(mapStateToProps)(OrderOptionsItemsTab);